import { ToolbarDef } from "../search-param.model";
import { TranslateService } from '@ngx-translate/core';
import { ToolbarAction } from "../../se-toolbar/se-buttons-toolbar/types";

export function executionToolbarDef(translate: TranslateService): ToolbarDef[] {
    return [
        // {
        //    label: translate.instant('RemoveExam'), // RIMUOVI ESAME
        //    actionType: ToolbarAction.EXE_CANCEL,
        //    permission: 231,
        //    isToggle: false,
        //    hasChildren: false,
        //    children: [],
        //    status: {
        //        visible: true,
        //        disabled: true,
        //        visibleIntoToolbar: false,
        //        visibleIntoContext: true
        //    }
        //},
        {
            label: translate.instant('TitleAdmission'), // ACCETTAZIONE DIRETTA
            actionType: ToolbarAction.ADMISSION,
            permission: 239,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: true,
                visibleIntoContext: false
            }
        },
        {
            label: translate.instant('Patient'), // PAZIENTE
            actionType: ToolbarAction.PATIENT,
            permission: 1,
            isToggle: false,
            hasChildren: true,
            children: [
                {
                    label: translate.instant('MasterData'), // ANAGRAFICA
                    actionType: ToolbarAction.PATIENT_REGISTRY,
                    permission: 240,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                },
                {
                    label: translate.instant('RadiologyFolder'), // CARTELLA PAZIENTE
                    actionType: ToolbarAction.RADIOLOGY_FOLDER,
                    permission: 3,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                }
            ],
            status: {
                visible: true,
                disabled: false,
                visibleIntoToolbar: false,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('TitleAdministrativeDashboard'), // CRUSCOTTO AMMINISTRATIVO
            actionType: ToolbarAction.ADMINISTRATION_DASHBOARD,
            permission: 0,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: false,
                visibleIntoContext: true // funzionalità soggetta ad autorizzazione per profilo
            }
        },
        {
            label: translate.instant('FeaAuthorizationMngt'), // GESTIONE AUTORIZZAZIONE FEA
            actionType: ToolbarAction.FEA_AUTH_MANAGEMENT,
            permission: 126,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: false,
                visibleIntoContext: true // Funzionalità soggetta a Setting
            }
        },
        {
            label: translate.instant('ExamManagement'), // GESTIONE ESAME
            actionType: ToolbarAction.EXAM_MANAGEMENT,
            permission: 241,
            isToggle: false,
            hasChildren: true,
            children: [
                {
                    label: translate.instant('ModifyExam'), // MODIFICA ESAME
                    actionType: ToolbarAction.EDIT_EXAM,
                    permission: 9,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                },
                {
                    label: translate.instant('AddExam'), // AGGIUNGI ESAME
                    actionType: ToolbarAction.ADD_EXAM,
                    permission: 8,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                },
                {
                    label: translate.instant('DeleteExamination'), // CANCELLA ESAME
                    actionType: ToolbarAction.EXE_CANCEL,
                    permission: 2,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                },
                {
                    label: translate.instant('ModifyExamination'), // MODIFICA DETTAGLI
                    actionType: ToolbarAction.EDIT_EXAMINATION,
                    permission: 10,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                }
            ],
            status: {
                visible: true,
                disabled: false,
                visibleIntoToolbar: true,
                visibleIntoContext: true
            }
        },
       
        {
            label: translate.instant('SendToWorklist'), // INVIA A DIAGNOSTICA
            actionType: ToolbarAction.SEND_TO_WORKLIST,
            permission: 18,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: true, // Funzionalità che dipende dalla configurazione macchina
                visibleIntoContext: true  // Funzionalità che dipende dalla configurazione macchina
            }
        },
        {
            label: translate.instant('Execute'), // ESEGUI 
            actionType: ToolbarAction.EXE_EXECUTE_AS_LOGGED_USER,
            permission: 233,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: true,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('ExeExecuteOther'), // ESEGUI COME..
            actionType: ToolbarAction.EXE_EXECUTE_OTHER,
            permission: 234,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: true,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('UndoExecution'), // ANNULLA ESECUZIONE
            actionType: ToolbarAction.EXE_UNDO_EXECUTION,
            permission: 235,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: true,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('SuspendExamination'), // SOSPENDI ESAME
            actionType: ToolbarAction.EXE_SUSPEND,
            permission: 232,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: true,
                visibleIntoContext: true
            }
        }, 
        {
            label: translate.instant('UndoSuspension'), // ANNULLA SOSPENSIONE
            actionType: ToolbarAction.UNDO_SUSPENSION,
            permission: 16,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: true,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('UnloadDevices'), // SCARICO MATERIALI
            actionType: ToolbarAction.UNLOAD,
            permission: 4,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: false,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('ViewImages'), // VISUALIZZA IMMAGINI
            actionType: ToolbarAction.VIEW_IMAGES,
            permission: 5,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: false,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('EnableWebDelivery'), // ABILITA REFERTO ONLINE
            actionType: ToolbarAction.ENABLE_WEB_DELIVERY,
            permission: 57,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: false,
                visibleIntoContext: true // se disponibile in base a setting sito e configurazione CDC/Provenienza
            }
        },
        {
            label: translate.instant('DisableWebDelivery'), // DISABILITA REFERTO ONLINE
            actionType: ToolbarAction.DISABLE_WEB_DELIVERY,
            permission: 58,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: false,
                visibleIntoContext: true // se disponibile in base a setting sito e configurazione CDC/Provenienza
            }
        },
        {
            label: translate.instant('ViewAnamnesticData'), // VISUALIZZA DATI ANAMNESTICI
            actionType: ToolbarAction.VIEW_ANAMNESTIC_DATA,
            permission: 242,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: true, // vedi documento IRENE
                visibleIntoContext: true  // vedi documento IRENE
            }
        },
        {
            label: translate.instant('Prints'), // STAMPE
            actionType: ToolbarAction.PRINTS,
            permission: 54,
            isToggle: false,
            hasChildren: true,
            children: [
                {
                    label: translate.instant('PrintLabel'), // STAMPA ETICHETTA
                    actionType: ToolbarAction.PRINT_LABELS,
                    permission: 21,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                },
                {
                    label: translate.instant('PrintList'), // STAMPA LISTA
                    actionType: ToolbarAction.PRINT_LIST,
                    permission: 22,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                },
                {
                    label: translate.instant('PrintModules'), // STAMPA MODULI
                    actionType: ToolbarAction.PRINT_MODULES,
                    permission: 23,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                },
                {
                    label: translate.instant('PrintReport'), // STAMPA REFERTO
                    actionType: ToolbarAction.PRINT_REPORT,
                    permission: 25,
                    isToggle: false,
                    hasChildren: false,
                    children: [],
                    status: {
                        visible: true,
                        disabled: false,
                        visibleIntoToolbar: true,
                        visibleIntoContext: true
                    }
                }, 
            ],
            status: {
                visible: true,
                disabled: false,
                visibleIntoToolbar: true,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('AttachedDocuments'), // DOCUMENTI ALLEGATI
            actionType: ToolbarAction.ATTACHED_DOCS,
            permission: 24,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: false,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('SendToRemoteReporting'), // INVIA A REFERTATORE REMOTO
            actionType: ToolbarAction.SEND_TO_REMOTE_REPORTING,
            permission: 119,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: false,
                visibleIntoContext: true
            }
        },
        {
            label: translate.instant('CreateRemoteConsultation'), // CREA TELECONSULTO
            actionType: ToolbarAction.CREATE_TELECONSULTATION,
            permission: 123,
            isToggle: false,
            hasChildren: false,
            children: [],
            status: {
                visible: true,
                disabled: true,
                visibleIntoToolbar: false,
                visibleIntoContext: true
            }
        },
        
    ]
}
